export const environment = {
  captchaSiteKey: '6LcRHU0UAAAAAHmC6oXArllZjYIo7_TpZeZ5FU5r',
  production: false,
  apiUrl: 'https://api-qa.mobileinsight.com/api/',
  publicUrl: 'https://api-qa.mobileinsight.com/api/',
  appUrl: 'https://qa-viba.mobileinsight.com/redirect/',
  salesforceAppUrl: 'https://test.salesforce.com',
  showNotProductionBanner: true,
  notProductionBannerText: 'This is the QA environment',
  googleMapsApiKey: 'AIzaSyAjFMh04q4lhZLvi88QXmd0J4OnjGFzZ9I',
  micrositeBaseUrl: 'https://qa-viba-microsite.mobileinsight.com',
  androidInstallerUrl: 'https://storage.googleapis.com/qa-viba-cms-content/android/ViBA-Kiosk-Android-latest.apk',
  androidUpdateFeedUrl: 'https://storage.googleapis.com/qa-viba-cms-content/android/',
  electronInstallerUrl: 'https://storage.googleapis.com/qa-viba-cms-content/electron/ViBA-Kiosk-Setup-latest.exe',
  electronUpdateFeedUrl: 'https://storage.googleapis.com/qa-viba-cms-content/electron/'
};
